__turbopack_context__.v({
  "example": "CodeExample-module__E2kq4q__example",
  "toolbar": "CodeExample-module__E2kq4q__toolbar",
});
